import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16v-8l4 8v-8","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-1"}]]

const IconSquareRoundedLetterN = createReactComponent('outline', 'square-rounded-letter-n', 'SquareRoundedLetterN', __iconNode);

export default IconSquareRoundedLetterN;